import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Moment from 'moment';
import { API_URL } from '../../api/ApiSettings';


const initialState = {
  searchingComplaint: {
    complaintPosition:{},
    complaintHeader:{},
    customer:{}
  
}
}

export const searchComplaint = createAsyncThunk(
  'complaint/searchComplaint',
  async ({ number, password }, { dispatch }) => {
    try {
      const url = `${API_URL}complaint/getComplaintByNumber?number=${number}&password=${password}`;
      const response = await fetch(url);
      const result = await response.json();
      if (response.status === 200) {
        const {complaintHeader,customer} = result;
        const complaintPosition = result.complaintPositions[0];
        complaintPosition.dateOfReceiptOfGoods = Moment(
          complaintPosition.dateOfReceiptOfGoods
        );
        complaintPosition.faultDate = Moment(complaintPosition.faultDate);
        if (complaintPosition.emails.length > 0) {
          complaintPosition.emails.map((email) => {
            email.sendingDate = Moment(email.sendingDate);
          });
        }
        return {complaintHeader,complaintPosition,customer};

     }
    } catch (error) {
      
      throw new Error(
        'Błąd krytyczny!',
        'Nie można pobrać danych. Skontaktuj się z administratorem aplikacji'
      );
    }
  }
);
const searchComplaintSlice = createSlice({
  name: 'searchComplaint',
  initialState,
  reducers: {
    changeComplaintType: (state, action) => {
      state.searchingComplaint.complaintHeader.complaintType = action.payload;
    },

  },
  extraReducers: {
    [searchComplaint.fulfilled]: (state, action) => {
      state.searchingComplaint = action.payload;
    },
}
});

export const { changeComplaintType } = searchComplaintSlice.actions;

export default searchComplaintSlice.reducer;